import React from 'react'
import { Button, Typography, Space, theme } from 'antd'
import { ExclamationCircleFilled } from '@ant-design/icons'
import Modal, { ModalProps } from '@/Core/UI/Modal/Modal'

const { Title, Paragraph } = Typography
const { useToken } = theme

export interface DeleteModalProps extends Pick<ModalProps, 'open' | 'onCancel'> {
    onConfirm: () => void
    title?: string
    description?: string
    okButtonText?: string
}

export const DeleteModal: React.FC<DeleteModalProps> = ({
    open,
    onCancel,
    onConfirm,
    okButtonText,
    title = 'Ви впевнені, що хочете видалити?',
    description = 'Після видалення не можна буде відновити.',
}) => {
    const { token } = useToken()

    return (
        <Modal open={open} footer={null} onCancel={onCancel} centered width={420}>
            <Space orientation="vertical" size={24} style={{ width: '100%' }}>
                {/* Іконка + текст */}
                <Space size={16} align="start">
                    <div
                        style={{
                            width: 48,
                            height: 48,
                            borderRadius: '50%',
                            background: token.colorErrorBg,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0,
                        }}
                    >
                        <ExclamationCircleFilled style={{ fontSize: 24, color: token.colorError }} />
                    </div>

                    <Space orientation="vertical" size={4}>
                        <Title level={5} style={{ margin: 0 }}>
                            {title}
                        </Title>

                        <Paragraph type="secondary" style={{ margin: 0 }}>
                            {description}
                        </Paragraph>
                    </Space>
                </Space>

                {/* Кнопки */}
                <Space style={{ width: '100%', justifyContent: 'flex-end' }}>
                    <Button onClick={onCancel}>Скасувати</Button>

                    <Button danger type="primary" onClick={onConfirm}>
                        {okButtonText ?? 'Видалити'}
                    </Button>
                </Space>
            </Space>
        </Modal>
    )
}
